<template>
  <div>
    <v-dialog max-width="400px" persistent v-model="opened">
      <v-card>
        <v-card-title>
          <h4 class="text-truncate ma-0">Change SRS Code</h4>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-5">
          <v-text-field
            filled
            readonly
            label="Item No."
            v-model="srsCode.product.itemNumber"
          />
          <v-text-field
            filled
            readonly
            label="Current Srs Code"
            v-model="srsCode.srsCode"
          />
          <v-text-field
            filled
            :disabled="savingSrsCode"
            hide-details
            label="New Srs Code"
            v-model="newSrsCode"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            :disabled="savingSrsCode"
            text
            @click="onCancelClicked()"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isNewSrsCodeValid || savingSrsCode"
            :loading="savingSrsCode"
            text
            @click="onSaveSrsCodeClicked()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api";
import timers from "../../utils/timers";
export default {
  props: {
    opened: {
      type: Boolean,
      required: false,
      default: false,
    },
    srsCode: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  }, // props

  data: () => ({
    newSrsCode: "",
    savingSrsCode: false,
  }), // data

  computed: {
    isNewSrsCodeValid() {
      return (
        this.newSrsCode != undefined &&
        this.newSrsCode != null &&
        this.newSrsCode.trim().length > 0
      );
    },
  }, // computed

  methods: {
    onCancelClicked() {
      this.$emit("cancel");
    },

    onSaveSrsCodeClicked() {
      this.saveSrsCodeAsync();
    },

    async saveSrsCodeAsync() {
      if (!this.isNewSrsCodeValid) return;

      try {
        this.savingSrsCode = true;
        await timers.wait(1000);
        await api.vipSales.enqueueSrsCodeChangeAsync(
          this.srsCode.product.itemNumber,
          this.srsCode.srsCode,
          this.newSrsCode
        );
        this.$emit("saved");
      } finally {
        this.savingSrsCode = false;
      }
    },
  }, // methods
};
</script>
